import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BrandExclusionBox } from '../components/ControlPanelBoxes';

const BrandExclusion = () => {
  const navigate = useNavigate();

  return (
    <main className="app-main">
      <div className="page-nav">
        <button className="back-btn" onClick={() => navigate('/control-panel')}>← Control Panel</button>
        <span className="page-nav__title">Brand Exclusion</span>
      </div>

      <BrandExclusionBox />
    </main>
  );
};

export default BrandExclusion;
